import React, {FC, useState} from 'react'
import {useAppDispatch} from 'redux/config'
import {useRouter} from '@uirouter/react'
import {
  Button,
  Icon,
  Search,
  Stack,
} from '@mdsol/onex-design'
import {useSelector} from 'react-redux'
import {
  select_gridSession_filters_searchQuery,
  select_jobs_showFilters,
  select_gridSession_filters_areDirty,
  select_gridSession_filters,
  select_rescheduleJobs_noneSelected,
  select_rescheduleJobs_selectedJobIds,
} from 'redux/jobs/selectors'
import {rescheduleFailedJobs} from 'redux/jobs/jobs.duck'
import {jobsAC, refreshJobs} from 'redux/jobs/jobs.duck'
import {customMessageRequest, genericRequestError} from 'redux/toast/toast.duck'
import {thunkWithSpeedBump} from 'redux/speedBump/speedBump.duck'
import {SpeedBumpType} from 'redux/speedBump/state'

import FiltersPanel from './FiltersPanel'
import {select_auth_user} from 'redux/auth/selectors'

const GridControl: FC = () => {
  const dispatch = useAppDispatch()
  const router = useRouter()

  const defaultSearchQuery = useSelector(select_gridSession_filters_searchQuery)
  const [searchQuery, setSearchQuery] = useState(defaultSearchQuery)

  const showFilters = useSelector(select_jobs_showFilters)
  const areFiltersDirty = useSelector(select_gridSession_filters_areDirty)

  const filtersShowClass = 'onex-btn--icon onex-btn--filled onex-btn--default'
  const filtersHideClass = filtersShowClass + ' onex-btn--indicator onex-btn--indicator--unread'

  const filtersButtonClass = !showFilters && areFiltersDirty ? filtersHideClass : filtersShowClass

  const selectedFilters = useSelector(select_gridSession_filters)

  const areNoJobsSelectedForRescheduling = useSelector(select_rescheduleJobs_noneSelected)
  const jobIdsSelectedForRescheduling = useSelector(select_rescheduleJobs_selectedJobIds)

  const {isAdmin, isPowerUser} = useSelector(select_auth_user)
  const toggleFilters = () => {
    dispatch(jobsAC.showFiltersToggled())
  }

  const handleSearchQueryChange = value => {
    setSearchQuery(value)
  }

  const handleKeyPress = target => {
    if(target.key === 'Enter') {
      const filters = {
        ...selectedFilters,
        searchQuery: searchQuery,
      }

      dispatch(refreshJobs(router, undefined, undefined, filters))
    }
  }

  const handleClear = () => {
    const filters = {
      ...selectedFilters,
      searchQuery: '',
    }

    dispatch(refreshJobs(router, undefined, undefined, filters))
  }

  const handleRescheduleJobs = () => {
    dispatch(thunkWithSpeedBump(rescheduleFailedJobs, SpeedBumpType.rescheduleFailedJobs, jobIdsSelectedForRescheduling, router))
  }

  const handleRefresh = async () => {
    try {
      await router.stateService.reload()
      dispatch(customMessageRequest('information', 'Jobs have been refreshed.', 1000))
    } catch (err) {
      dispatch(genericRequestError())
    }
  }

  return (
    <>
      <div className='onex-data-grid-control'>
        <div className='onex-data-grid-control__actions'>
          <Stack className='buttons-panel' direction='horizontal' gap={2}>
            {(isAdmin || isPowerUser) && <Button
              dataTestId='reschedule-jobs-button'
              size='sm'
              leadingIcon={<Icon key='key-reschedule-failed-jobs-icon'>restart_alt</Icon>}
              disabled={areNoJobsSelectedForRescheduling}
              onClick={handleRescheduleJobs}
            >
              Reschedule
            </Button>
            }

            <Button
              className='refresh-button jobs-refresh'
              dataTestId='db-refresh-button'
              onClick={handleRefresh}
              size='sm'
              leadingIcon={<Icon key='key-jobs-filters-panel-refresh-leading-icon'>refresh</Icon>}
            >
              Refresh
            </Button>

            <Button
              dataTestId='filters-toggle-button'
              onClick={toggleFilters}
              className={filtersButtonClass}
              variant='secondary'
            >
              <Icon>filter_alt</Icon>
              <Icon>{showFilters ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</Icon>
            </Button>
          </Stack>

          <Search
            placeholder='Search'
            showClearBtn
            dataTestId='search-field'
            value={searchQuery}
            onChange={value => handleSearchQueryChange(value)}
            onKeyPress={handleKeyPress}
            onClear={handleClear}
          />
        </div>
      </div>

      {showFilters && <FiltersPanel />}
    </>
  )
}

export default GridControl
